import { useQuery } from '@tanstack/react-query';
import instanceAxios from '@/util/axios';
import { AuthUser } from '@/types';

export const getMe = async (): Promise<AuthUser> => {
  const { data } = await instanceAxios.get<AuthUser>('pvt/me');
  return data;
};

export const useMe = (enabled = true) => useQuery<AuthUser>({ queryKey: ['me'], queryFn: getMe, enabled });
